import TabContainer from '@/components/common/TabContainer';
import CardLayout from '@/components/Layout/CardLayout';
import Layout from '@/components/Layout/Layout';
import FullPageLoader from '@/components/loader/FullPageLoader';
import BackButton from '@/components/ui/BackButton';
import { showToastNotification } from '@/utility/helper';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { Nav, NavItem } from 'reactstrap';
import EmployeeBasicDetailsStep1 from '../HRM/HrmSettings/EmployeeOnboard/onBoardFormSteps/EmployeeBasicDetailsStep1';
import EmployeeAdvanceDetailsStep3 from '../HRM/HrmSettings/EmployeeOnboard/onBoardFormSteps/EmployeeAdvanceDetailsStep3';
import EmployeeAddressDetailsStep4 from '../HRM/HrmSettings/EmployeeOnboard/onBoardFormSteps/EmployeeAddressDetailsStep4';
import EmployeeBankDetailsStep5 from '../HRM/HrmSettings/EmployeeOnboard/onBoardFormSteps/EmployeeBankDetailsStep5';
import EmployeeNomineeDetailsStep6 from '../HRM/HrmSettings/EmployeeOnboard/onBoardFormSteps/EmployeeNomineeDetailsStep6';
import EmployeePreviousWorkStep7 from '../HRM/HrmSettings/EmployeeOnboard/onBoardFormSteps/EmployeePreviousWorkStep7';
import EmployeeDocumentsStep8 from '../HRM/HrmSettings/EmployeeOnboard/onBoardFormSteps/EmployeeDocumentsStep8';
import {
  IAddEmployeeForm,
  IEmployeePageStates,
} from '@/interfaces/employee.model';
import { useEffect, useState } from 'react';
import { IDocument, IUser } from '@/interfaces/user.model';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
import moment from 'moment';

const UpdateProfile = () => {
  const userDetails = useSelector((state: RootState) => state?.user?.user);
  const id = userDetails?.id;
  const [pageStates, setPageStates] = useState<IEmployeePageStates>({
    activeTab: 1,
    empId: null,
  });
  const [imageFile, setImageFile] = useState<File | string | null>(null);
  const [employeeDetail, setEmployeeDetails] = useState<IUser | null>(
    userDetails ? userDetails : null,
  );
  const [existingDocuments, setExistingDocuments] = useState<IDocument[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const methods = useForm<IAddEmployeeForm>();
  const {
    reset,
    handleSubmit,
    // formState: { errors },
    setValue,
  } = methods;

  useEffect(() => {
    if (id) {
      setPageStates((prev) => ({
        ...prev,
        empId: id,
      }));
    } else {
      setValue('status', 'current');
    }
  }, [id, pageStates.activeTab, setValue]);
  useEffect(() => {
    if (userDetails) {
      setIsLoading(true);
      setEmployeeDetails(userDetails);
      reset({
        firstName: userDetails?.name.split(' ')[0],
        lastName: userDetails?.name.split(' ')[1],
        bloodGroup: userDetails?.bloodGroup ?? '',
        profilePhoto: userDetails?.profilePhoto,
        dob: userDetails?.dob ?? '',
        email: userDetails?.email,
        personalEmail: userDetails?.personalEmail,
        ecpName: userDetails?.userdetail?.ecpName,
        ecpPhone: userDetails?.userdetail?.ecpPhone,
        motherName: userDetails?.userdetail?.motherName ?? '',
        fatherName: userDetails?.userdetail?.fatherName ?? '',
        gender: userDetails?.gender,
        isMarried: userDetails?.isMarried?.toString(),
        skillType: userDetails?.skillType ?? '',
        joiningDate:
          (userDetails?.joiningDate &&
            moment(userDetails?.joiningDate).format('YYYY-MM-DD')) ??
          '-',
        isSameAsPermanentAddress:
          userDetails?.userdetail?.isSameAsPermanentAddress,
        phone: userDetails?.phone,
        status: userDetails?.status,
        officeId: userDetails?.officeId ?? '',
        departmentId: userDetails?.departmentId ?? '',
        designationId: userDetails?.designationId ?? '',
        employeeCode: userDetails?.employeeCode ?? '',
        address: userDetails?.userdetail?.address ?? '',
        state: userDetails?.userdetail?.state ?? '',
        city: userDetails?.userdetail?.city ?? '',
        permanentAddress: userDetails?.userdetail?.permanentAddress ?? '',
        pinCode: userDetails?.userdetail?.pinCode ?? '',
        permanentCity: userDetails?.userdetail?.permanentCity ?? '',
        permanentPinCode: userDetails?.userdetail?.permanentPinCode ?? '',
        permanentState: userDetails?.userdetail?.permanentState ?? '',
        uanNumber: userDetails?.userdetail?.uanNumber ?? '',
        aadharNumber: userDetails?.userdetail?.aadharNumber ?? '',
        esicNumber: userDetails?.userdetail?.esicNumber ?? '',
        drivingLicenseNumber:
          userDetails?.userdetail?.drivingLicenseNumber ?? '',
        insuranceNumber: userDetails?.userdetail?.insuranceNumber ?? '',
        panNumber: userDetails?.userdetail?.panNumber ?? '',
        pfNumber: userDetails?.userdetail?.pfNumber ?? '',
        bankName: userDetails?.userdetail?.bankName ?? '',
        accountNumber: userDetails?.userdetail?.accountNumber ?? '',
        accountHolderName: userDetails?.userdetail?.accountHolderName ?? '',
        ifscCode: userDetails?.userdetail?.ifscCode ?? '',
        branchAddress: userDetails?.userdetail?.branchAddress ?? '',
        nomineeDob: userDetails?.userdetail?.nomineeDob ?? '',
        nomineeName: userDetails?.userdetail?.nomineeName ?? '',
        nomineeRelation: userDetails?.userdetail?.nomineeRelation ?? '',
        nomineePhone: userDetails?.userdetail?.nomineePhone ?? '',
        shiftId: userDetails?.shiftId ?? '',
      });
      setImageFile(userDetails?.profilePhoto);
      setExistingDocuments(userDetails?.documents);
      setIsLoading(false);
    }
  }, [reset, userDetails]);

  const formSteps = [
    {
      tabId: 1,
      label: 'Basic Details',
    },
    {
      tabId: 2,
      label: 'Advance Details',
    },
    {
      tabId: 3,
      label: 'Address',
    },
    {
      tabId: 4,
      label: 'Bank Details',
    },
    {
      tabId: 5,
      label: 'Nominee Details',
    },
    {
      tabId: 6,
      label: 'Previous Work',
    },
    {
      tabId: 7,
      label: 'Documents',
    },
  ];

  const onSubmit: SubmitHandler<IAddEmployeeForm> = () => {
    if (!imageFile) {
      showToastNotification('danger', 'Please add image');
      return;
    }
    setPageStates((prev) => ({
      ...prev,
      activeTab: pageStates.activeTab + 1,
    }));
  };
  const nextStep = () => {
    setPageStates((prev) => ({
      ...prev,
      activeTab: pageStates.activeTab + 1,
    }));
  };

  return (
    <Layout>
      <div className="content container-fluid">
        <BackButton label="Profile" isEdit={Boolean(id)} />
        <CardLayout cardStyle="mb-4">
          <div className="wizard-tabs">
            <Nav tabs className="nav nav-pills ">
              {formSteps.map((step, index) => {
                return (
                  <>
                    <NavItem key={step.tabId}>
                      <Link
                        to={'#'}
                        className={
                          pageStates.activeTab === step.tabId
                            ? 'border-0 p-2 active  nav-link'
                            : ' nav-link'
                        }
                        style={{ cursor: 'pointer' }}
                        onClick={
                          pageStates.empId || step?.tabId == 1
                            ? () =>
                                setPageStates((prev) => ({
                                  ...prev,
                                  activeTab: step?.tabId,
                                }))
                            : () => {
                                const isUpdateFlow = !!id;
                                if (isUpdateFlow) {
                                  setPageStates((prev) => ({
                                    ...prev,
                                    activeTab: step?.tabId,
                                  }));
                                } else if (
                                  !pageStates.empId &&
                                  (step?.tabId === 1 || step?.tabId === 2)
                                ) {
                                  setPageStates((prev) => ({
                                    ...prev,
                                    activeTab: step?.tabId,
                                  }));
                                } else if (!pageStates.empId) {
                                  showToastNotification(
                                    'danger',
                                    'Please complete the creation process before proceeding.',
                                  );
                                } else if (
                                  pageStates.empId &&
                                  step?.tabId > 2
                                ) {
                                  setPageStates((prev) => ({
                                    ...prev,
                                    activeTab: step?.tabId,
                                  }));
                                } else {
                                  showToastNotification(
                                    'info',
                                    'Basic Details and Permissions can only be updated later.',
                                  );
                                }
                              }
                        }
                      >
                        <h6>Step {step?.tabId}</h6>
                        <h5>{step.label}</h5>
                      </Link>
                    </NavItem>{' '}
                    {formSteps?.length - 1 != index && (
                      <li className="nav-item">
                        <div className="border-top-item" />
                      </li>
                    )}
                  </>
                );
              })}
            </Nav>
          </div>
        </CardLayout>
        {/* <CardLayout> */}
        {isLoading ? (
          <FullPageLoader />
        ) : (
          <FormProvider {...methods}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <TabContainer activeTab={pageStates.activeTab} tabId={1}>
                <EmployeeBasicDetailsStep1
                  nextStep={nextStep}
                  setImageFile={setImageFile}
                  imageFile={imageFile}
                  empId={pageStates?.empId}
                  isProfile={true}
                />
              </TabContainer>
              {/* <TabContainer activeTab={pageStates.activeTab} tabId={2}>
                <EmployeePermissionStep2
                  nextStep={nextStep}
                  imageFile={imageFile}
                  setPageStates={setPageStates}
                />
              </TabContainer> */}
              <TabContainer activeTab={pageStates.activeTab} tabId={2}>
                <EmployeeAdvanceDetailsStep3
                  empId={pageStates?.empId}
                  nextStep={nextStep}
                />
              </TabContainer>
              <TabContainer activeTab={pageStates.activeTab} tabId={3}>
                <EmployeeAddressDetailsStep4
                  nextStep={nextStep}
                  empId={pageStates.empId}
                />
              </TabContainer>
              <TabContainer activeTab={pageStates.activeTab} tabId={4}>
                <EmployeeBankDetailsStep5
                  nextStep={nextStep}
                  empId={pageStates.empId}
                />
              </TabContainer>
              <TabContainer activeTab={pageStates.activeTab} tabId={5}>
                <EmployeeNomineeDetailsStep6
                  nextStep={nextStep}
                  empId={pageStates.empId}
                />
              </TabContainer>
              <TabContainer activeTab={pageStates.activeTab} tabId={6}>
                <EmployeePreviousWorkStep7
                  nextStep={nextStep}
                  empId={pageStates.empId}
                  previousWork={employeeDetail?.previousworks}
                />
              </TabContainer>
              <TabContainer activeTab={pageStates.activeTab} tabId={7}>
                <EmployeeDocumentsStep8
                  existingDocuments={existingDocuments}
                  setExistingDocuments={setExistingDocuments}
                  empId={pageStates.empId}
                  nextStep={nextStep}
                />
              </TabContainer>
              {/* <TabContainer activeTab={pageStates.activeTab} tabId={9}>
                <EmployeeSalaryDetailStep9
                  pageStates={salaryPageStates}
                  empId={pageStates.empId}
                  getEmployeeDetail={getEmployeeDetail}
                  setPageStates={setSalaryPageStates}
                />
              </TabContainer> */}
            </form>
          </FormProvider>
        )}
      </div>
    </Layout>
  );
};

export default UpdateProfile;
